// /app/frontend/src/components/frugal-v2/i18n/index.js
// Independent i18n for Frugal V2 - NO dependency on monolith (50 lines)

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import es from '../locales/es.json';

// Create a separate i18n instance for Frugal V2
const frugalI18n = i18n.createInstance();

frugalI18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
    },
    lng: localStorage.getItem('zensaver_language') || 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

// Change language and persist
export const changeLanguage = (lng) => {
  frugalI18n.changeLanguage(lng);
  localStorage.setItem('zensaver_language', lng);
};

// Get current language
export const getCurrentLanguage = () => {
  return frugalI18n.language || 'es';
};

export default frugalI18n;
